import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import action_library_messages from 'messages/action_library_messages';

import ActionTemplateForm from './ActionTemplateForm';
import useActionTemplateFormManager from './useActionTemplateFormManager';

const ActionLibraryCreatePage: React.FC = () => {
  const { t } = useTranslation();
  const { setIsDirty, saveHandlerRef, handleNavigation, NavigationPrompt } = useActionTemplateFormManager({});

  return (
    <Container>
      <NavigationPrompt />
      <ManagePageHeader backButton onBack={handleNavigation} subtitle={t(action_library_messages.create_subtitle)}>
        {t(action_library_messages.create_button)}
      </ManagePageHeader>
      <ActionTemplateForm onCancelNavigation={handleNavigation} onDirtyStateChange={setIsDirty} onSaveRequestRef={saveHandlerRef} />
    </Container>
  );
};

export default ActionLibraryCreatePage;
